module.exports = __webpack_public_path__ + "static/maps-c06a7db4087d4d79e5a666f4a4fce6b7.png";